import React, { Component } from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { validateEmailFormat, downloadBlob } from "../../Global/tools.js";

import Input from "../../Nano/Input.js";

//IMAGES
import { ReactComponent as Edit } from "../../Global/Icons/edit.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";
import { ReactComponent as Excel } from "../../Global/Icons/excel.svg";
import { ReactComponent as PDF } from "../../Global/Icons/pdf.svg";
import { ReactComponent as ArrowDown } from "../../Global/Icons/arrowDown.svg";
import { ReactComponent as Plus } from "../../Global/Icons/plus.svg";
import { ReactComponent as Minus } from "../../Global/Icons/minus.svg";
import { ReactComponent as Graph } from "../../Global/Icons/graph.svg";

//SERVICES
import accountService from "../../../services/AccountService.js";

const multiple = nota.global.multiple;

const StyledMySubscription = styled(NanoFlex)`
  height: 100%;
  padding: ${multiple * 2 + "px"};

  .headerWrapper {
    height: auto;
    margin-bottom: ${multiple * 3 + "px"};
    h2 {
      text-transform: uppercase;
      em {
        text-transform: none;
        font-weight: bold;
        color: ${nota.color.main.default};
      }
    }
    p {
      margin-left: ${multiple * 2 + "px"};
      margin-bottom: 2px;
      width: 60%;
    }
  }

  .secondaryWrapper {
    height: auto;
    margin-bottom: ${multiple * 3 + "px"};
    .asideWrapper {
      width: auto;
    }
  }
  /* SELECT BTN */
  .selectBtn {
    height: 38px;
    width: auto;
    margin-right: ${multiple + "px"};
    user-select: none;
    .optionWrapper {
      background-color: ${nota.color.neutral.NeuFour};
      width: 100%;
      cursor: pointer;
      padding: ${multiple + "px"};
      p {
        text-transform: uppercase;
      }
      .checkBoxWrapper {
        height: 100%;
        width: auto;
        padding-right: ${multiple + "px"};
        svg {
          width: 18px;
          height: 10px;
          path {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }

      &:hover {
        opacity: 0.7;
      }
    }
    .selectedOption {
      background-color: ${nota.color.main.default};
      p {
        color: ${nota.color.neutral.white};
      }
      .checkBoxWrapper {
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }
  /* INPUT --- secondaryWrapper */
  .inputWrapper {
    width: auto;
    min-width: 250px;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .editIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      cursor: pointer;
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.neutral.NeuThree};
        }
      }
      &:hover {
        svg {
          path {
            fill: ${nota.color.neutral.NeuTwo};
          }
        }
      }
    }
  }

  /* SUBSCRIPTIONS LIST */
  .listContainer {
    margin-bottom: ${multiple + "px"};
    &:last-child {
      margin-bottom: 0;
    }
  }
  /* SUBSCRIPTION ITEM */
  .itemContainer {
    /* padding: ${multiple * 2 + "px"}; */
    border: 1px solid ${nota.color.neutral.NeuFour};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin-bottom: ${multiple * 2 + "px"};
    /* HEADER ITEM */
    .headerItem {
      padding: ${multiple * 2 + "px"};
      .asideContainer {
        .iconsWrapper {
          width: auto;
          .iconContainer {
            cursor: pointer;
            margin: ${multiple + "px"};
            svg {
              height: 20px;
              width: auto;
              path {
                fill: ${nota.color.neutral.NeuOne};
              }
            }
            &:hover {
              svg {
                path {
                  fill: ${nota.color.main.default};
                }
              }
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .rightAside {
        width: 280px;
      }
    }
    /* RESTRICTIONS */
    .restrictionsWrapper {
      background-color: ${nota.color.neutral.lightGrey};
      padding: ${multiple * 2 + "px"};
      .listWrapper {
        background-color: ${nota.color.neutral.white};
        padding: ${multiple * 2 + "px"};
        height: auto;
        .listTitleWrapper {
          margin-bottom: ${multiple + "px"};
          height: auto;
        }
        /* ACCORDION LIST */
        .accordionList {
          /* max-height: calc(100vh - 433px);
              min-height: auto; */
          height: 300px;
          overflow: auto;
          .accordionItem {
            height: auto;
            min-height: -webkit-fit-content;
            margin-bottom: ${multiple / 2 + "px"};
            .mainInfo {
              height: auto;
              min-height: -webkit-fit-content;
              margin-bottom: ${multiple / 2 + "px"};
              padding: ${multiple + "px"};
              border-left: 4px solid ${nota.color.main.default};
              cursor: pointer;
              .rightContainer {
                width: auto;
                .iconWrapper {
                  width: auto;
                  padding: 4px;
                  svg {
                    path {
                      fill: ${nota.color.neutral.NeuFive};
                    }
                  }
                }
                .activeIconWrapper {
                  svg {
                    path {
                      fill: ${nota.color.main.mFour};
                    }
                  }
                }
              }
              .collapseBtn {
                transform: rotate(180deg);
                padding-right: 32px;
                padding-left: 0;
                width: auto;

                svg {
                  height: 8px;
                  width: auto;
                  path {
                    fill: ${nota.color.main.default};
                  }
                }
              }
              &:hover {
                background-color: ${nota.color.neutral.NeuFour};
                .rightContainer {
                  .iconWrapper {
                    svg {
                      path {
                        fill: ${nota.color.neutral.NeuTwo};
                      }
                    }
                  }
                  .activeIconWrapper {
                    svg {
                      path {
                        fill: ${nota.color.main.mFour};
                      }
                    }
                  }
                }
              }
            }
            .secondaryInfo {
              height: auto;
              .secItem {
                background-color: ${nota.color.neutral.lightGrey};
                margin-bottom: ${multiple / 2 + "px"};
                padding: ${multiple + "px"};
                padding-left: ${multiple * 2 + "px"};
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
          .collapsedItem {
            .mainInfo {
              .collapseBtn {
                transform: rotate(0deg);
                padding-right: 0;
                padding-left: 32px;
                svg {
                  path {
                    fill: ${nota.color.main.default};
                  }
                }
              }
            }
            .secondaryInfo {
              display: none;
            }
          }
        }

        /* SCROLL LIST */
        .scrollList {
          /* max-height: calc(100vh - 433px);
              min-height: auto; */
          height: 300px;
          overflow: auto;
          .scrollItem {
            background-color: ${nota.color.neutral.lightGrey};
            margin-bottom: ${multiple / 2 + "px"};
            padding: ${multiple + "px"};
            height: 32px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .itemContainer {
      .headerItem {
        flex-direction: column;
        .rightAside {
          width: 100%;
          margin-top: 4px;
        }
      }
      .restrictionsWrapper {
        flex-direction: column;
        .listWrapper {
          margin-bottom: 4px;
          .listTitleWrapper {
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
            .iconTitleWrapper {
              width: auto;
              padding-right: 6px;
              margin-left: 8px;
              cursor: pointer;
              svg {
                height: auto;
                width: 14px;
                path {
                  fill: ${nota.color.main.default};
                }
              }
              .maximize {
                display: none;
              }
              .minimize {
                display: flex;
                path {
                  fill: ${nota.color.main.mTwo};
                }
              }
            }
          }
          .accordionList {
            height: auto;
            margin-top: 16px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
        .collapsedListWrapper {
          .listTitleWrapper {
            .iconTitleWrapper {
              .maximize {
                display: flex;
              }
              .minimize {
                display: none;
              }
            }
          }
          .accordionList {
            display: none;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .secondaryWrapper {
      .asideWrapper {
        .selectBtn {
          .optionWrapper {
            min-width: 100px;
            text-align: center;

            .checkBoxWrapper {
              display: none;
            }
            p {
              font-size: 12px;
              line-height: 12px;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 400px) {
    .secondaryWrapper {
      .asideWrapper {
        flex-direction: column;
        width: 100%;
        .inputWrapper {
          width: 100%;
          min-width: auto;
          margin-top: 4px;
        }
      }
    }
  }
`;

class DailyUpdateConfig extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isActive: null,
      email: "",
      emailError: false,
    };

    this.emailChangeId = 0;
  }

  componentDidMount() {
    super.componentDidMount();
    this.getDailyUpdateConfig();
  }

  componentDidUpdate(prevProps, prevState) {
    /* Config Changed */
    if (!prevState.loading && (prevState.isActive !== this.state.isActive || prevState.email !== this.state.email)) {
      /* Save Config */
      this.setDailyUpdateConfig();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  getDailyUpdateConfig = () => {
    accountService
      .getDailyUpdateConfig()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({
          isActive: data.isActive,
          email: data.email,
          loading: false,
        });
      });
  };

  setDailyUpdateConfig = () => {
    accountService
      .setDailyUpdateConfig({
        isActive: this.state.isActive,
        email: this.state.email,
      })
      .then((response) => {
        if (!response.ok) {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      });
  };

  onIsActiveClick = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  onEmailChange = (val) => {
    this.emailChangeId++;
    var emailChangeId = this.emailChangeId;
    setTimeout(() => {
      if (emailChangeId === this.emailChangeId) {
        if (val && val.trim() !== "" && validateEmailFormat(val) == false) {
          this.setState({ emailError: true });
        } else {
          this.setState({ email: val, emailError: false });
        }
      }
    }, 1000);
  };

  render() {
    if (this.state.loading) return null;
    return (
      <NanoFlex className="secondaryWrapper" justifyContent={"space-between"} alignContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="asideWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
          <NanoFlex className="selectBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start" onClick={this.onIsActiveClick}>
            <NanoFlex className={`optionWrapper ${this.state.isActive ? "selectedOption" : ""}`} justifyContent="flex-start">
              <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                <Check />
              </NanoFlex>
              <Type.p>{this.translation.myCompanySubscription.activateDailyUpdate}</Type.p>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
            <Input defaultValue={this.state.email} title={null} placeholder={"email@email.com"} error={this.state.emailError} onChangeAction={this.onEmailChange} />
            <NanoFlex className="editIconWrapper">
              <Edit />
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

class ChannelsGroupItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <NanoFlex key={this.props.item.id} className={`accordionItem ${!this.state.isOpen ? "collapsedItem" : ""}`} flexDirection={"column"} onClick={this.toggleOpen}>
        <NanoFlex className="mainInfo" justifyContent={"space-between"} alignContent={"flex-start"} alignItems={"flex-start"}>
          <Type.p>
            <b>{this.props.item.name}</b>
          </Type.p>
          <NanoFlex className="rightContainer" justifyContent={"flex-end"} alignContent={"flex-end"}>
            <NanoFlex className={`iconWrapper ${this.props.item.hasMsh ? "activeIconWrapper" : ""}`} title={this.props.item.hasMsh ? "Audience Results Included" : "Audience Results Excluded"}>
              <Graph />
            </NanoFlex>
            <NanoFlex className="collapseBtn">
              <ArrowDown />
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="secondaryInfo" flexDirection={"column"}>
          {this.props.item.channels &&
            this.props.item.channels.map((sg) => {
              return (
                <NanoFlex key={sg.id} className="secItem" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                  <Type.p>{sg.name}</Type.p>
                </NanoFlex>
              );
            })}
        </NanoFlex>
      </NanoFlex>
    );
  }
}

class GenreItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <NanoFlex key={this.props.item.id} className={`accordionItem ${!this.state.isOpen ? "collapsedItem" : ""}`} flexDirection={"column"} onClick={this.toggleOpen}>
        <NanoFlex className="mainInfo" justifyContent={"space-between"} alignContent={"flex-start"} alignItems={"flex-start"}>
          <Type.p>
            <b>{this.props.item.name}</b>
          </Type.p>
          <NanoFlex className="collapseBtn" justifyContent={"flex-end"} alignContent={"flex-end"}>
            <ArrowDown />
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="secondaryInfo" flexDirection={"column"}>
          {this.props.item.subGenres &&
            this.props.item.subGenres.map((sg) => {
              return (
                <NanoFlex key={sg.id} className="secItem" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                  <Type.p>{sg.name}</Type.p>
                </NanoFlex>
              );
            })}
        </NanoFlex>
      </NanoFlex>
    );
  }
}

class AccessItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      isGenresOpen: true,
      isChannelsGroupOpen: true,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  toggleGenreOpen = () => {
    this.setState({ isGenresOpen: !this.state.isGenresOpen });
  };

  toggleChannelsGroupOpen = () => {
    this.setState({ isChannelsGroupOpen: !this.state.isChannelsGroupOpen });
  };

  getAccessReport = () => {
    accountService
      .getAccessReport(this.props.item.id)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
        return null;
      })
      .then((blob) => {
        if (blob) {
          downloadBlob(blob, `Subscription-Report.xlsx`);
        }
        this.setState({ isLoading: false });
      });
  };

  render() {
    return (
      <NanoFlex key={this.props.item.id} className="itemContainer" flexDirection={"column"}>
        {/* HEADER ITEM */}
        <NanoFlex className="headerItem">
          <NanoFlex className="asideContainer" flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
            <Type.h3>
              <b>{this.props.item.name}</b>
            </Type.h3>
            <Type.p>{this.props.item.description}</Type.p>
          </NanoFlex>
          <NanoFlex className="asideContainer rightAside" flexDirection={"column"} justifyContent={"flex-end"} alignContent={"flex-end"} alignItems={"flex-end"}>
            <Type.p>{this.translation.myCompanySubscription.period}</Type.p>
            <Type.p>
              <b>
                {this.props.item.beginDate} {this.props.item.beginDate && this.props.item.endDate ? "-" : ""} {this.props.item.endDate}
              </b>
            </Type.p>
            <NanoFlex className="iconsWrapper" justifyContent={"flex-end"} alignContent={"flex-end"}>
              <NanoFlex className="iconContainer" title={this.translation.components.navSearchList.exportExcel} onClick={this.getAccessReport}>
                <Excel />
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
        {/* RESTRICTIONS */}
        <NanoFlex className="restrictionsWrapper" justifyContent={"flex-start"} alignItems={"stretch"} alignContent={"stretch"}>
          {/* GENRES LIST */}
          <NanoFlex className={`listWrapper ${this._isMobile && this.state.isGenresOpen ? "collapsedListWrapper" : ""}`} flexDirection={"column"} alignItems={"stretch"}>
            <NanoFlex className="listTitleWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
              <Type.p>
                <b>
                  <em>{this.translation.myCompanySubscription.genreSubgenre}</em>
                </b>
              </Type.p>
              {this._isMobile && (
                <NanoFlex className="iconTitleWrapper" onClick={this.toggleGenreOpen}>
                  <Plus className="maximize" />
                  <Minus className="minimize" />
                </NanoFlex>
              )}
            </NanoFlex>
            {/* ACCORDION LIST */}
            <NanoFlex className="accordionList" flexDirection={"column"} justifyContent={"flex-start"}>
              {/* ACCORDION ITEM */}
              {this.props.item.genres &&
                this.props.item.genres.map((g, i) => {
                  return <GenreItem key={i} item={g} />;
                })}
            </NanoFlex>
            {/* END ACCORDION LIST */}
          </NanoFlex>
          {/* CHANNELS LIST */}
          <NanoFlex className={`listWrapper ${this._isMobile && this.state.isChannelsGroupOpen ? "collapsedListWrapper" : ""}`} flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"stretch"}>
            <NanoFlex className="listTitleWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
              <Type.p>
                <b>
                  <em>{this.translation.myCompanySubscription.countriesChannels}</em>
                </b>
              </Type.p>
              {this._isMobile && (
                <NanoFlex className="iconTitleWrapper" onClick={this.toggleChannelsGroupOpen}>
                  <Plus className="maximize" />
                  <Minus className="minimize" />
                </NanoFlex>
              )}
            </NanoFlex>
            {/* SCROLL LIST */}
            <NanoFlex className="accordionList" flexDirection={"column"} justifyContent={"flex-start"}>
              {/* ACCORDION ITEM */}
              {this.props.item.channelsGroups &&
                this.props.item.channelsGroups.map((cg) => {
                  return <ChannelsGroupItem item={cg} />;
                })}
            </NanoFlex>
            {/* END SCROLL LIST */}
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

export class MySubscription extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      accesses: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onMySubscriptionLanguageChange, false);

    this.getAccesses();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onMySubscriptionLanguageChange, false);
  }

  onMySubscriptionLanguageChange = () => {
    this.getAccesses();
  };

  getAccesses = () => {
    accountService
      .getAccesses()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ accesses: data });
      });
  };

  render() {
    return (
      <StyledMySubscription>
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          {/* HEADER */}
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"center"}>
            <Type.h2>
              <em>{this.translation.myCompanySubscription.title}</em>
            </Type.h2>
          </NanoFlex>
          {/* SECONDARY HEADER */}
          {this._user.HasDailyUpdateAccess && <DailyUpdateConfig />}

          {/* SUBSCRIPTIONS LIST */}
          <NanoFlex className="listContainer" flexDirection={"column"}>
            {/* SUBSCRIPTION ITEM */}
            {this.state.accesses &&
              this.state.accesses.map((item, i) => {
                return <AccessItem key={i} item={item} />;
              })}
          </NanoFlex>
          {/* END SUBSCRIPTIONS LIST */}
        </NanoFlex>
      </StyledMySubscription>
    );
  }
}
